import * as d3 from "d3";
import {
    colonAnnotation, contextMenu,
    createTooltip,
    fw_progressive_1way, generateDownloadData,
    inrFormatter,
    responsivefy,
} from '../functions'

export default function (chart, divId, vizName, resData,filterParam) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //var tempVar = chart.tempVar

    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    // axios.post(url, filterParam).then(res => {
        let data = resData
    console.log(data)

        var margin = 25;

        var x1Scale = d3.scaleLinear().range([0, chart.width - 12 * margin]);
        var y1Scale = d3.scaleLinear().range([0, chart.height - 6 * margin]);
        var metric1ColorScale = d3.scaleOrdinal(fw_progressive_1way)

        var n = inrFormatter,
            p = d3.format(".0%");

        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId).append("svg")
            .attr("width", chart.width)
            .attr("height", chart.height + 20)
            .call(responsivefy)
            .append("g")
            .attr("transform", "translate(" + 2 * margin + "," + margin + ")");

        var offset = 0;

        var segments = d3.nest()
            .key(function (d) {
                return d.dim2_name;
            })
            .entries(data);
        console.log(segments)

        var sum = segments.reduce(function (v, p) {
            return (
                (p.offset = v) +
                (p.sum = p.values.reduceRight(function (v, d) {
                    d.parent = p;
                    return (d.offset = v) + d.metric1;
                }, 0))
            );
        }, 0);

        // Add x-axis ticks.
        console.warn(offset)
        var xtick = svg.selectAll(".x")
            .data(segments)
            .enter()
            .append("g")
            .attr("class", "x")
            .attr("transform", function (d) {
                return "translate(" + x1Scale((d.offset + d.sum / 2) / sum) + "," + y1Scale(1) + ")";
            });

        xtick.append("line").attr("y2", 10).style("stroke", "#000");

        xtick.append("text")
            .attr("text-anchor", "start")
            .attr("dx", "-8em")
            .attr("dy", ".71em")
            .attr("font-size", axisLabelFontSize / 2)
            .attr('transform', 'rotate(-50)')
            .text(function (d) {
                if (d.key.length > 15)
                    return d.key.substring(0, 15) + "~ "
                else {
                    let j = 15 - d.key.length;
                    for (let i = 1; i <= j; i++) {
                        d.key = d.key + " .";
                    }
                    return d.key + " ."
                }
            })

        // Add y-axis ticks.
        var ytick = svg.selectAll(".y")
            .data(y1Scale.ticks(10))
            .enter()
            .append("svg:g")
            .attr("class", "y")
            .attr("transform", function (d) {
                return "translate(0," + y1Scale(1 - d) + ")";
            });

        ytick.append("svg:line").attr("x1", -6).style("stroke", "#000");

        ytick.append("svg:text")
            .attr("x", -8)
            .attr("text-anchor", "end")
            .attr("font-size", axisLabelFontSize / 2)
            .attr("dy", ".35em")
            .text(p);

        // Add a group for each cause.
        var segment = svg.selectAll(".segment")
            .data(segments)
            .enter()
            .append("g")
            .attr("class", "segment")
            .attr("xlink:title", (d) => {
                return d.key
            })
            .attr("transform", (d) => {
                return "translate(" + x1Scale(d.offset / sum) + ")"
            });

        // add total on each column
        svg.selectAll(".segment")
            .append("text")
            .attr("font-size", "10px")
            .text(function (d) {
                return n(d.sum);
            }) // total
            .attr("x", 5)
            .attr("y", -5) // 470 to bototm

        // Add X axis label:
        svg.append("text")
            .attr("text-anchor", "end")
            .attr("x", chart.width / 2)
            .attr("y", chart.height - 2 * chart.axisLabelDistance)
            .text(chart.x1AxisDisplayName)
            .style("fill", fontColor)
            .style('font-size', fontSize);

        /*svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0- 10*chart.axisLabelDistance)
            .attr('x', 0 - (chart.height / 2))
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y1AxisDisplayName)
            .style('font-size',fontSize)*/

        // Add a rect for each month.
        var retailers = segment
            .selectAll(".segment")
            .data(function (d) {
                return d.values;
            })
            .enter()
            .append("a")
            .attr("class", "segment")

        // d3.select(".d3-tip" + divId.id).remove(); // clear tooltip based on class of tip element
        // var y1tip = tooltip_class()

        // y1tip.attr('class', 'd3-tip' + divId.id)
        //     .html(function (d) {
        //         return d.parent.key + " - " + d.dim1_name + colonAnnotation + n(d.metric1) + "<br/>" +
        //             d.dim1_name + " is " + d.metric2 + " %  of " + d.parent.key + " Revenue " + "<br/>" +
        //             d.parent.key + " is " + d.metric3 + " % of " + d.dim1_name + " Revenue " + "<br/>";
        //     })

        // svg.call(y1tip);

        // d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        // var div = d3.select(divId).append('div').attr('class', 'tooltip')
        //     .attr('style', 'position: absolute; opacity: 0;')

    const tooltip = createTooltip(divId)


        retailers.append("rect")
            .attr("y", function (d) {
                return y1Scale(d.offset / d.parent.sum)
            })
            .attr("height", function (d) {
                return y1Scale(d.metric1 / d.parent.sum) - 2
            })
            .attr("width", function (d) {
                return x1Scale(d.parent.sum / sum) - 2
            })
            .style("fill", function (d) {
                return metric1ColorScale(d.dim1_name)
            })
            .on('mouseover', function( d) {
                tooltip.onMouseOver(d, this, function(d) {
                    // Tooltip content callback
                    return d.parent.key + " - " + d.dim1_name + colonAnnotation + n(d.metric1) + "<br/>" +
                        d.dim1_name + " is " + d.metric2 + " %  of " + d.parent.key + " Revenue " + "<br/>" +
                        d.parent.key + " is " + d.metric3 + " % of " + d.dim1_name + " Revenue " + "<br/>"
                });  // Pass the event for positioning
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
            })
            .on('mouseout', function() {
                tooltip.onMouseLeave();  // Hide the tooltip on mouse leave
            })
            .on('contextmenu', function(d) {
                // Determine if we clicked a state or district
                console.log(d)
                const clickedData={
                    [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]:[d.dim1_name],
                    [chart.insightNavigator.realDataFieldNames.y1RealDataFieldName]:[d.dim2_name]
                }

                console.log("clickedData", clickedData);
                const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);
                contextMenu(menuItems).call(this, clickedData);
                d3.event.preventDefault();
            })

        retailers.append("text")
            .attr("font-size", "10px")
            .text(function (d) {
                return d.metric2 + "%"
            })
            .attr("text-anchor", "end")
            .attr("transform", function (d) {
                var xText = x1Scale(d.parent.sum / sum) / 25 + 25;
                var yText = y1Scale(d.offset / d.parent.sum) + (y1Scale(d.metric1 / d.parent.sum) / 2 - 6)
                return "translate(" + xText + "," + yText + ") rotate(-90)";
            })

        retailers.append("text")
            .attr("font-size", "10px")
            .text(function (d) {
                return d.metric3 + "%"
            })
            .attr("x", function (d) {
                return x1Scale(d.parent.sum / sum) / 25 + 25
            })
            .attr("y", function (d) {
                return y1Scale(d.offset / d.parent.sum) + (y1Scale(d.metric1 / d.parent.sum) / 2);
            })

        var y1legend = svg.selectAll('.legend')
            .data(metric1ColorScale.domain().reverse())
            .enter().append('g')
            .attr('class', 'legend')
            .attr("transform", function (d, i) {
                return "translate(25," + i * 20 + ")";
            });

        y1legend.append('rect')
            .attr('x', chart.width - 250)
            .attr('width', 18)
            .attr('height', 18)
            .style('fill', metric1ColorScale)

        y1legend.append('text')
            .attr("font-size", "10px")
            .attr('x', chart.width - 225)
            .attr('y', 9)
            .attr('dy', '.35em')
            .text(function (d) {
                return d
            })
    // });
}
